import userApi from '@/api/sy/user'

const user = {
  state: {
    id: null,
    empId: null,
    name: '',
    // unitName: '',
    cityId: 0,
    dataRange: 0,
  },
  getters: {
    hasIdentityInfo: state => {
      return state.id != null
    },
    isLogin: state => {
      return localStorage.getItem("token") ? true : false
    }
  },
  mutations: {
    SET_ID(state, id) {
      state.id = id
    },
    SET_NAME(state, name) {
      state.name = name
    },
    SET_EMPID(state, empId) {
      state.empId = empId
    },
    // SET_UNITNAME(state, unitName) {
    //   state.unitName = unitName;
    // },
    SET_CITYID(state, cityId) {
      state.cityId = cityId;
    },
    SET_DATA_RANGE(state, dataRange) {
      state.dataRange = dataRange
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        userApi.login(user).then(res => {
          
          if (res.Code == 0) {
            localStorage.setItem("token", res.Data.Token);
            localStorage.setItem("refresh", res.Data.RefreshToken);
            localStorage.setItem("mode", res.Data.DisplayMode == 1); //true: 多标签，false：单标签
            localStorage.setItem("theme", "#009966"); //true: 多标签，false：单标签

            let loginInfo = {
              UserId: res.Data.Id,
              EmpId: res.Data.EmpId,
              UserName: res.Data.Name,
              CityId: res.Data.CityId
              // UnitName: res.Data.UnitName
            }


            localStorage.setItem("loginInfo", JSON.stringify(loginInfo));

            resolve(res);
          } else {
            reject(res);
          }
        })
      })
    },
    getIdentityInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {

        var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

        commit('SET_ID', loginInfo.UserId)
        commit('SET_NAME', loginInfo.UserName)
        commit('SET_EMPID', loginInfo.EmpId)
        // commit('SET_UNITNAME', loginInfo.UnitName)
        commit('SET_CITYID', loginInfo.CityId)

        userApi.getPermission().then(res => {
          let dataRange = res.Data.Roles.some(item => item.DataRange == 1)
          commit('SET_DATA_RANGE', dataRange)
          function buildPermissionAndFullPath(menu) {
            res.Data.Menus.forEach((m, i) => {
              if (m.Pid == menu.MenuId) {
                m.FullPath = menu.FullPath + '/' + m.Url;
                m.PermissionPath = (menu.PermissionPath ? (menu.PermissionPath + '.') : "") + m.Url;
                buildPermissionAndFullPath(m);
              }
            })
          }
          buildPermissionAndFullPath({
            MenuId: 0,
            FullPath: "",
            PermissionPath: ""
          });
          commit("SET_PERMISSION_MENUS", res.Data.Menus, { root: true });
          resolve(res.Data)
        }).catch(error => {
          dispatch('logout')
          reject(error)
        })
      })
    },
    refreshToken({ commit }) {
      return new Promise((resolve, reject) => {
        let data = {
          Token: localStorage.getItem("token"),
          RefreshToken: localStorage.getItem("refresh")
        }
        // 
        userApi.refreshToken(data).then(res => {
          // 
          if (res.Code == 0 && res.Data != null) {
            localStorage.setItem("token", res.Data.Token);
            localStorage.setItem("refresh", res.Data.RefreshToken);
            console.log("localStorage",localStorage);
            // sessionStorage.setItem("token", res.Data.Token);
            // sessionStorage.setItem("refresh", res.Data.RefreshToken);
          }
          resolve(res)
        })
      })
    },
    logout({ commit }) {

      userApi.Logout().then(res => {

        if (res.Code == 0) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh");
          localStorage.removeItem("loginInfo");
          window.location.reload();
        } else {
          reject(res);
        }
      })
    }
  }
}
export default user
